export const CABINET_DASHBOARD_PATHS = {
  /** GET /cabinet/stats?date=YYYY-MM-DD */
  STATS: (date) => `/cabinet/stats?date=${date}`,

  /** GET /cabinet/appointments?date=YYYY-MM-DD&view=day|week|month */
  APPOINTMENTS: (date, view) => `/cabinet/appointments?date=${date}&view=${view}`,
};
